import { useState, useEffect } from "react";
import {fetchTasksService}  from "../services/tasksService";

const useUserTasks = (initialPage = 1, initialSize = 10) => {
  const [tasks, setTasks] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [page, setPage] = useState(initialPage);
  const [pageSize, setPageSize] = useState(initialSize);
  const [totalPages, setTotalPages] = useState(1);

  const fetchTasks = async (page, pageSize) => {
    setLoading(true);
    setError("");
  
    try {
      const res = await fetchTasksService(page, pageSize); 
      setTasks(res.data.tasks || res.data);
      const total = res.data.total;
      setTotalPages(Math.ceil(total / pageSize));
    } catch (err) {
      console.error("Failed to fetch tasks:", err);
        if (err.response) {
        const status = err.response.status;
        if (status >= 500) {
          setError("Server is currently down. Please try again later.");
        } else if (status === 404) {
          setError("Requested resource not found.");
        } else if (status === 401) {
          setError("Unauthorized. Please login again.");
        } else if (status === 400) {
          setError("Invalid request. Please check parameters.");
        } else {
          setError("Something went wrong. Please try again.");
        }
      } else if (err.request) {
        setError("No response from server. Please check your internet connection.");
      } else {
        setError("Unexpected error occurred.");
      }
  
    } finally {
      setLoading(false);
    }
  };
  

  useEffect(() => {
    fetchTasks(page, pageSize);
  }, [page, pageSize]);

  return {
    tasks,
    setTasks,
    loading,
    error,
    page,
    setPage,
    pageSize,
    setPageSize,
    totalPages,
  };
};

export default useUserTasks;
